import { localize } from '@deriv/translations';

export const CFD_TEXT = {
    dxtrade: () => localize('Deriv X'),
    mt5: () => localize('MT5'),
    mt5_cfds: () => localize('MT5 CFDs'),
    ctrader: () => localize('cTrader'),
    cfd: () => localize('CFDs'),
    synthetic: () => localize('Derived'),
    synthetic_demo: () => localize('Derived Demo'),
    synthetic_bvi: () => localize('Derived BVI'),
    synthetic_svg: () => localize('Derived SVG'),
    synthetic_v: () => localize('Derived Vanuatu'),
    financial: () => localize('Financial'),
    financial_demo: () => localize('Financial Demo'),
    financial_bvi: () => localize('Financial BVI'),
    financial_fx: () => localize('Financial Labuan'),
    financial_v: () => localize('Financial Vanuatu'),
    financial_svg: () => localize('Financial SVG'),
    derivez: () => localize('Deriv EZ'),
    all: () => localize('Swap-Free'),
    all_demo: () => localize('Swap-Free Demo'),
    all_svg: () => localize('Swap-Free SVG'),
};
